import { IDataGrid } from "../../IDataGrid";
import { Column } from "../Columns/Column";
import { IDataRowElement } from "./IDataRow";

export class Cell {
    protected _column: Column;
    protected _index: number;
    protected _owner: IDataGrid<IDataRowElement>;

    private _interactive: boolean;

    public get interactive(): boolean {
        return this._interactive;
    }

    public set interactive(v: boolean) {
        this._interactive = v;
    }

    public get column(): Column {
        return this._column;
    }

    constructor(owner: IDataGrid<IDataRowElement>, index: number, column: Column) {
        this._owner = owner;
        this._index = index;
        this._column = column;
    }

    public dispose(): void {
        // Prazdna metoda
    }

    public init(): void {
        // Prazdna metoda
    }

    public preRender(): void {
        // Prazdna metoda
    }

    public render(): HTMLElement {
        return null;
    }
}
